module.exports = __webpack_public_path__ + "img/chinesecompany01.74511e69.png";